import { useState } from "react";
import { Send, Trash2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const mmss = (t) => { const s = Math.floor(t); return s >= 3600 ? `${Math.floor(s / 3600)}:${String(Math.floor((s % 3600) / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}` : `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`; };

export function CommentLine({ c, canDelete, onDelete, onSeek, dark }) {
  return (
    <li className={`flex items-start gap-2 text-sm ${dark ? "text-white" : "text-q-text"}`} data-testid={`comment-${c.id}`}>
      <button className={`shrink-0 font-mono text-xs ${dark ? "text-white/60" : "text-q-muted"} ${onSeek ? "underline" : ""}`} onClick={onSeek} disabled={!onSeek} data-testid={`comment-time-${c.id}`}>{mmss(c.t)}</button>
      <span className="min-w-0 flex-1 break-words"><b>{c.name}</b> {c.deleted ? <i className="opacity-60" data-testid={`comment-removed-${c.id}`}>Comment removed</i> : c.text}</span>
      {!c.deleted && canDelete && <button className="flex h-11 w-11 shrink-0 items-center justify-center opacity-70" aria-label="Delete comment" onClick={onDelete} data-testid={`comment-delete-${c.id}`}><Trash2 className="h-4 w-4" /></button>}
    </li>
  );
}

// Side panel on desktop/iPad, bottom sheet on phones.
export function CommentsPanel({ base, comments, open, onClose, meKey, parent }) {
  const [text, setText] = useState("");
  const [err, setErr] = useState("");
  const post = async (e) => {
    e.preventDefault();
    if (!text.trim() || text.trim().length > 500) { setErr("Comments can be up to 500 characters."); return; }
    try { await api.post(`${base}/comments`, { text }); setText(""); setErr(""); } catch (x) { setErr(x?.response?.data?.detail || errMsg(x)); }
  };
  const del = (c) => api.delete(`${base}/comments/${c.id}`).catch((x) => toast.error(errMsg(x)));
  return (
    <aside className={`${open ? "flex" : "hidden"} fixed inset-x-0 bottom-0 z-[95] max-h-[60vh] flex-col rounded-t-3xl bg-zinc-900 p-4 lg:static lg:flex lg:max-h-none lg:w-80 lg:rounded-none lg:border-l lg:border-white/10`} data-testid="call-comments-panel">
      <div className="mb-2 flex items-center justify-between text-white"><p className="font-display font-extrabold">Comments</p>
        <button className="flex h-11 w-11 items-center justify-center lg:hidden" onClick={onClose} aria-label="Close comments" data-testid="call-comments-close"><X className="h-5 w-5" /></button></div>
      <ul className="min-h-0 flex-1 space-y-2 overflow-y-auto" data-testid="call-comments-list">
        {!comments.length && <li className="text-sm text-white/50">No comments yet.</li>}
        {comments.map((c) => <CommentLine key={c.id} c={c} dark canDelete={c.key === meKey || parent} onDelete={() => del(c)} />)}
      </ul>
      <form className="mt-3 flex gap-2" onSubmit={post}>
        <input className="min-h-[44px] min-w-0 flex-1 rounded-full bg-white/10 px-4 text-white placeholder:text-white/40" placeholder="Say something 🎉" value={text} onChange={(e) => { setText(e.target.value); setErr(""); }} data-testid="call-comment-input" />
        <button className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white text-black" aria-label="Send comment" data-testid="call-comment-send"><Send className="h-4 w-4" /></button>
      </form>
      {err && <p className="mt-2 text-xs font-semibold text-amber-300" data-testid="call-comment-error">{err}</p>}
    </aside>
  );
}
